import { GridColDef, GridActionsCellItem } from "@mui/x-data-grid"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import SaveIcon from "@mui/icons-material/Save"
import CancelIcon from "@mui/icons-material/Close"
import moment from "moment"
import { Invoice } from "src/api/modules/invoice-api"

const getInvoiceListColumns = (
  handleEdit: (id: string) => void,
  handleDelete: (id: string) => void,
  handleSave: (id: string) => void,
  handleCancel: (id: string) => void,
  isInEditMode: (id: string) => boolean
) => {
  const invoiceListColumns: GridColDef<Invoice>[] = [
    {
      field: "secondaryId",
      headerName: "ID",
      flex: 1,
      minWidth: 100,
      editable: false
    },
    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      flex: 1,
      minWidth: 150,
      editable: true
    },
    {
      field: "invoiceDate",
      headerName: "Invoice Date",
      flex: 1,
      minWidth: 120,
      editable: true,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY")
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      flex: 1,
      minWidth: 120,
      editable: true,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY")
    },
    {
      field: "clientName",
      headerName: "Client Name",
      flex: 1,
      minWidth: 150,
      editable: true
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 200,
      editable: true
    },
    {
      field: "taxRate",
      headerName: "Tax Rate",
      flex: 1,
      minWidth: 100,
      editable: true,
      type: "number",
      valueFormatter: ({ value }) => `${value}%`
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      editable: true
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 150,
      editable: false,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm")
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      minWidth: 150,
      editable: false,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm")
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      minWidth: 100,
      cellClassName: "actions",
      pinnable: true,
      getActions: ({ id }) => {
        if (isInEditMode(id as string)) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={() => handleSave(id as string)}
              color="primary"
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={() => handleCancel(id as string)}
              color="inherit"
            />
          ]
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={() => handleEdit(id as string)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDelete(id as string)}
            color="inherit"
          />
        ]
      }
    }
  ]

  return invoiceListColumns
}

export default getInvoiceListColumns
